export { default as CmsEmbeddedVideoCard } from './CmsEmbeddedVideoCard';
